export enum AnalyticsEventLabel {
  SUCCESS = 'success',
  ERROR = 'error',
}
